import { CommonModule } from '@angular/common';
import { Component, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-language-selector',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './language-selector.component.html',
  styleUrl: './language-selector.component.scss'
})
export class LanguageSelectorComponent {

  @Output() lang = this.translate.getBrowserLang();
  constructor(private translate: TranslateService) { }
  
  switchLanguage(language: string) {
    this.lang = language;
    this.translate.use(language);
  }
  
  getLanguage() {
    return this.lang;
  } 
}
